import { TableBody, TableCell, TableHead, TableRow } from "@mui/material"

// others
import { Category_Headers, NOT_APPLICABLE } from "../../../constants"
import { CategoryListingProps } from "../../../interfaceTypes/props"

// components
import { CustomPagination } from "../../common/CustomPagination"
import { CustomTableCell } from "../../common/CustomTableCell"
import { StickyTable } from "../../common/StickyTable"
import CategoryMenu from "./CategoryMenu"
import { TableSkeleton } from "../../skeletons/TableSkeleton"

const CategoryListing = ({ categories, loading , refetch} : CategoryListingProps) => {
  return (
    <StickyTable pagination={<CustomPagination loading={loading} />} height="370px">
      <TableHead>
        <TableRow hover>
          {Category_Headers.map((columnName, index) => 
            <TableCell 
              key={index} 
              component="th" 
              align={'left'} 
              width={index === Category_Headers.length - 1 ? '100px' : 'auto'} 
            >
              {columnName}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
          
      { loading ?         
        <TableSkeleton noOfRows={7} noOfCols={Category_Headers.length} />
        : <TableBody>
          {categories?.map((category) => {
            const { id, name, description } = category || {}

            return (
              <TableRow key={id} hover>
                <CustomTableCell value={name} maxWidth="376px" />
              
                <CustomTableCell value={description || NOT_APPLICABLE} maxWidth="300px" />
              
                <TableCell>
                  <CategoryMenu category={category} refetch={refetch} />
                </TableCell>
              </TableRow>
            )
          })}     
      </TableBody>     
      } 
    </StickyTable>
  )
}

export default CategoryListing